module.exports = __webpack_public_path__ + "static/CrimsonText-Bold-4406317ac75ff73f4f2a0f269bd9fc46.woff2";